module.exports = __webpack_public_path__ + "img/nav-right-with-contact-hyundai.ce376259.png";